// extracted by mini-css-extract-plugin
module.exports = {"root":"bottomBar_root__PsaGI","container":"bottomBar_container__gE0gA","bottomSpacer":"bottomBar_bottomSpacer__dJ6Wh"};